import { pick } from '@eastcoal/common/utils/object'

import { AuctionUserTransfer } from '../../../../../../../components/AuctionUserTransfer'
import { useAuctionListStore } from '../../../../Store/hooks/useStore'
import { ApplyInviteButton } from '../components/InviteButton'

export const BidMemberListUserPanel = () => {
  const { currentAuction } = useAuctionListStore(state =>
    pick(state, ['currentAuction'])
  )

  const { id: auctionId, memberId, kindId } = currentAuction || {}

  return (
    <AuctionUserTransfer
      auctionId={auctionId}
      entrustMemberId={memberId}
      extraActions={[<ApplyInviteButton key='bidMemberListInviteButton' />]}
      kindId={kindId}
    />
  )
}
